import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { FaHeart, FaSpinner, FaGlobe, FaLock } from 'react-icons/fa';
import { motion } from 'framer-motion';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, message, type = 'delete', numImages, title, isModal }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = () => {
    setIsDeleting(true);
    setTimeout(() => {
      onConfirm();
      setIsDeleting(false);
    }, 3000);
  };

  if (type === 'copy') {
    return (
      <motion.div
        key="copy-dialog"
        className="absolute inset-0 rounded-lg overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div 
          className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <motion.p 
            key="copy-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
            className="text-[15px] text-center text-white font-medium font-['VT323'] px-6"
          >
            Prompt copied to clipboard and form ✨
          </motion.p>
        </div>
      </motion.div>
    );
  }

  if (type === 'favorite') {
    return (
      <motion.div
        key="favorite-dialog"
        className="absolute inset-0 rounded-lg overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div 
          className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <motion.div 
            className="flex items-center gap-2"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
          >
            <FaHeart className={`w-[15px] h-[15px] ${message?.includes('Added') ? 'text-red-500' : 'text-white'}`} />
            <p className="text-[15px] text-center text-white font-medium font-['VT323'] px-6">
              {message}
            </p>
          </motion.div>
        </div>
      </motion.div>
    );
  }

  if (type === 'public-status') {
    return (
      <motion.div
        key="public-status-dialog"
        className="absolute inset-0 rounded-lg overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div 
          className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <motion.div 
            className="flex items-center gap-2"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
          >
            {message.includes('public') ? (
              <FaGlobe className="w-[15px] h-[15px] text-green-400" />
            ) : (
              <FaLock className="w-[15px] h-[15px] text-white" />
            )}
            <p className="text-[15px] text-center text-white font-medium font-['VT323'] px-6">
              {message}
            </p>
          </motion.div>
        </div>
      </motion.div>
    );
  }

  if (type === 'processing') {
    return (
      <motion.div
        key="processing-dialog"
        className="absolute inset-0 rounded-lg overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div 
          className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <motion.div 
            className="flex items-center gap-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
          >
            <FaSpinner className="w-[15px] h-[15px] text-white animate-spin" />
            <p className="text-[15px] text-center text-white font-medium font-['VT323']">
              Processing {numImages} image{numImages > 1 ? 's' : ''}
            </p>
          </motion.div>
        </div>
      </motion.div>
    );
  }

  if (type === 'downloading') {
    return (
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="downloading-dialog"
            className="absolute inset-0 rounded-lg overflow-hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div 
              className="absolute inset-0 bg-black/60 backdrop-blur-sm"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <motion.div 
                className="flex items-center gap-3"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                transition={{ duration: 0.3 }}
              >
                <FaSpinner className="w-[15px] h-[15px] text-white animate-spin" />
                <p className="text-[15px] text-center text-white font-medium font-['VT323']">
                  Downloading image...
                </p>
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  if (type === 'publish') {
    const isPrivateAction = message?.toLowerCase().includes('private');
    return (
      <motion.div
        key="publish-dialog"
        onClick={onClose}
        className="absolute inset-0 rounded-lg overflow-hidden z-[300]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div 
          className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        />
        <motion.div
          onClick={e => e.stopPropagation()}
          className="absolute inset-0 flex flex-col items-center justify-center z-[310] px-8 gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
        >
          {/* Title and Message */}
          <div className="flex flex-col items-center gap-3">
            <p className="text-[16px] text-white/70 font-medium font-['VT323']">
              {title}
            </p>
            <p className="text-[18px] text-white font-medium text-center font-['VT323']">
              {message}
            </p>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-3">
            <button
              onClick={onClose}
              className="h-8 px-4 text-[16px] text-white/70 hover:text-white transition-colors duration-200 font-['VT323']"
            >
              Cancel
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onConfirm();
              }}
              className={`h-8 px-4 text-[16px] text-white font-medium transition-colors duration-200 rounded font-['VT323'] ${
                isPrivateAction 
                  ? 'bg-white/20 hover:bg-white/30 active:bg-white/40' 
                  : 'bg-green-500 hover:bg-green-600 active:bg-green-700'
              }`}
            >
              Confirm
            </button>
          </div>
        </motion.div>
      </motion.div>
    );
  }

  // Grid view delete confirmation
  if (!isModal) {
    return (
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="grid-delete-dialog"
            onClick={onClose}
            className="absolute inset-0 rounded-lg overflow-hidden z-[300]"
          >
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-8">
              <p className="text-[15px] text-center text-white font-medium font-['VT323']">
                {isDeleting ? "Deleting..." : "Delete this image? This cannot be undone."}
              </p>
              {!isDeleting && (
                <div className="flex gap-3">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onClose();
                    }}
                    className="h-8 px-4 text-[14px] text-white/70 hover:text-white transition-colors duration-200 font-['VT323']"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete();
                    }}
                    className="h-8 px-4 text-[14px] text-white font-medium bg-red-500 hover:bg-red-600 active:bg-red-700 transition-colors duration-200 rounded font-['VT323']"
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  // Modal/carousel view delete confirmation
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="modal-delete-dialog"
          onClick={onClose}
          className="absolute inset-0 rounded-lg overflow-hidden z-[300]"
        >
          {/* Semi-transparent backdrop with blur */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
          
          {/* Content */}
          <div
            onClick={e => e.stopPropagation()}
            className="absolute inset-0 flex flex-col z-[310]"
          >
            {/* Message - positioned absolutely to center relative to entire card */}
            <div className="absolute inset-0 mx-8 flex flex-col items-center justify-center mb-[52px] gap-3">
              <p className="text-[16px] text-white/70 font-medium font-['VT323']">
                Delete Image
              </p>
              <p className="text-[18px] text-white font-medium text-center font-['VT323']">
                {isDeleting ? "Deleting..." : "Delete this image? This cannot be undone."}
              </p>
            </div>

            {/* Buttons fixed to bottom */}
            {!isDeleting && (
              <div className="absolute bottom-0 w-full p-3 flex justify-center gap-3 z-[320]">
                <button
                  onClick={onClose}
                  className="h-8 px-4 text-[16px] text-white/70 hover:text-white transition-colors duration-200 font-['VT323']"
                >
                  Cancel
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete();
                  }}
                  className="h-8 px-4 text-[16px] text-white font-medium bg-red-500 hover:bg-red-600 active:bg-red-700 transition-colors duration-200 rounded font-['VT323']"
                >
                  Delete
                </button>
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmDialog; 